export const teamsQueryKeys = {
  checkRecordsStatus: (teamId: string) => ['check_records_status', teamId],
  updateTeam: () => ['update_team'] as const,
  fetchTeam: (teamId?: number) => ['fetch_team', teamId]
}
